export const emptyOptionParts = () => ({
  underlying: '',
  year: '',
  month: '',
  day: '',
  optionType: 'C',
  strike: '',
});

export const buildOptionSymbol = (parts) => {
  const underlying = parts.underlying.trim().toUpperCase();
  if (!/^[A-Z][A-Z0-9.]{0,5}$/.test(underlying)) {
    return { symbol: '', error: 'Enter an underlying symbol of up to six letters, digits, or periods, starting with a letter.' };
  }
  if (!/^20\d{2}$/.test(parts.year)
    || !/^\d{1,2}$/.test(parts.month)
    || !/^\d{1,2}$/.test(parts.day)) {
    return { symbol: '', error: 'Enter a valid expiration year (2000-2099), month, and day.' };
  }
  const year = Number(parts.year);
  const month = Number(parts.month);
  const day = Number(parts.day);
  const expiration = new Date(Date.UTC(year, month - 1, day));
  if (expiration.getUTCFullYear() !== year
    || expiration.getUTCMonth() !== month - 1
    || expiration.getUTCDate() !== day) {
    return { symbol: '', error: 'Enter a valid calendar date for expiration.' };
  }
  if (!['C', 'P'].includes(parts.optionType)) {
    return { symbol: '', error: 'Choose Call (C) or Put (P).' };
  }
  if (!/^\d{1,5}(?:\.\d{1,3})?$/.test(parts.strike) || Number(parts.strike) <= 0) {
    return { symbol: '', error: 'Enter a strike price greater than zero and below 100,000, with up to three decimal places.' };
  }
  const [dollars, fraction = ''] = parts.strike.split('.');
  const strikeCode = `${Number(dollars)}${fraction.padEnd(3, '0')}`.padStart(8, '0');
  return {
    symbol: `${underlying}${parts.year.slice(-2)}${String(month).padStart(2, '0')}${String(day).padStart(2, '0')}${parts.optionType}${strikeCode}`,
    error: '',
  };
};

export const parseOptionSymbolParts = (symbol) => {
  const compact = String(symbol ?? '').trim().toUpperCase().replace(/^-/, '').replace(/\s+/g, '');
  const match = compact.match(/^([A-Z][A-Z0-9.]{0,5})(\d{2})(\d{2})(\d{2})([CP])(\d{1,8})$/);
  if (!match) return null;
  const [, underlying, year, month, day, optionType, strikeCode] = match;
  const parts = {
    underlying,
    year: `20${year}`,
    month: String(Number(month)),
    day: String(Number(day)),
    optionType,
    // Full OCC strikes are thousandths; shorthand strikes are whole dollars.
    strike: String(Number(strikeCode) / (strikeCode.length === 8 ? 1000 : 1)),
  };
  return buildOptionSymbol(parts).symbol ? parts : null;
};
